export const dadosGraficos = {
  grafico01: [
    {
      name: "Enfermeiro/a",
      value: 28.0,
    },
    {
      name: "Técnico/a ou auxiliar de enfermagem",
      value: 12.4,
    },
    {
      name: "Psicólogo/a",
      value: 10.1,
    },
    {
      name: "Fisioterapeuta",
      value: 9.6,
    },
    {
      name: "Agente comunitário de saúde",
      value: 8.7,
    },
    {
      name: "Farmacêutico/a",
      value: 7.3,
    },
    {
      name: "Assistente social",
      value: 7.3,
    },
    {
      name: "Médico/a",
      value: 6.4,
    },
    {
      name: "Nutricionista",
      value: 4.1,
    },
    {
      name: "Técnico/a de Lab. em Análises Clinicas",
      value: 0.9,
    },
    {
      name: "Recepcionista",
      value: 0.9,
    },
    {
      name: "Gerente",
      value: 0.9,
    },
    {
      name: "Coordenador/a",
      value: 0.9,
    },
    {
      name: "Agente de endemia",
      value: 0.9,
    },
    {
      name: "Técnico/a em Radiologia",
      value: 0.4,
    },
    {
      name: "Odontólogo/a",
      value: 0.4,
    },
    {
      name: "Maqueiro/a",
      value: 0.4,
    },
    {
      name: "Diretor/a técnico",
      value: 0.4,
    },
    {
      name: "Cozinheiro/a",
      value: 0.4,
    },
    {
      name: "Condutor/a de ambulância",
      value: 0.4,
    },
    {
      name: "Biomédico/a",
      value: 0.4,
    },
    {
      name: "Funcionário/a administrativo/a",
      value: 0.4,
    },
  ],
  grafico02: [
    { name: "Homens", value: 16.5 },
    { name: "Mulheres", value: 83.5 },
  ],
  grafico03: [
    {
      name: "31 a 40",
      value: 38,
    },
    {
      name: "21 a 30",
      value: 29.8,
    },
    {
      name: "41 a 50",
      value: 19.3,
    },
    {
      name: "51 a 60",
      value: 10.1,
    },
    {
      name: "61+",
      value: 2.8,
    },
  ],
  grafico04: [
    {
      name: "Parda",
      value: 49.5,
    },
    {
      name: "Branca",
      value: 36.7,
    },
    {
      name: "Preta",
      value: 10.1,
    },
    {
      name: "Amarela",
      value: 3.7,
    },
  ],
  grafico05: [
    {
      name: "PB",
      value: 49,
      qtd: 107,
    },
    {
      name: "PE",
      value: 10.5,
      qtd: 23,
    },
    {
      name: "RN",
      value: 10.5,
      qtd: 23,
    },
    {
      name: "BA",
      value: 9.6,
      qtd: 21,
    },
    {
      name: "CE",
      value: 5.5,
      qtd: 12,
    },
    {
      name: "AL",
      value: 4.1,
      qtd: 9,
    },
    {
      name: "MA",
      value: 4.1,
      qtd: 9,
    },
    {
      name: "PI",
      value: 4.1,
      qtd: 9,
    },
    {
      name: "SE",
      value: 4.1,
      qtd: 9,
    },
  ],
  grafico06: [
    { name: "Região metropolitana", value: 64.2 },
    { name: "Interior do estado", value: 34.4 },
    { name: "Ambas as regiões", value: 1.4 },
  ],
  grafico07: [
    {
      name: "Entre 2 e 3 salários mínimos (R$ 2.091 à R$ 3.135)",
      value: 31.7,
    },
    {
      name: "Até 2 salários mínimos (R$ 2.090)",
      value: 25.2,
    },
    {
      name: "Entre 3 a 6 salários mínimos (R$ 3.136 à R$ 6.270)",
      value: 23.4,
    },
    {
      name: "Até 1 salário mínimo (R$ 1.045)",
      value: 9.6,
    },
    {
      name: "Entre 6 e 10 salários mínimos (R$ 6.271 à R$ 10.450)",
      value: 5.5,
    },
    {
      name: "Entre 10 e 15 salários mínimos (R$ 10,451 a 15,675)",
      value: 2.8,
    },
    {
      name: "Mais de 15 salários mínimos (R$ 15,676)",
      value: 1.6,
    },
  ],
  grafico09: [
    { name: "Sim", value: 65.6 },
    { name: "Não", value: 34.4 },
  ],
  grafico10: [
    {
      name: "Pós-grad.",
      value: 61.4,
    },
    {
      name: "Ens. sup.",
      value: 31.7,
    },
    {
      name: "Ens. méd./téc.",
      value: 6.4,
    },
    {
      name: "Ens. fund.",
      value: 0.5,
    },
  ],
  grafico13: [
    { name: "Sim", value: 53.2 },
    { name: "Não", value: 46.8 },
  ],
  grafico16: [
    { name: "Sim", value: 44 },
    { name: "Não", value: 56 },
  ],
  grafico18: [
    { name: "Sim", value: 70.2 },
    { name: "Não", value: 29.8 },
  ],
  grafico19: [
    { name: "Sim", value: 86.2 },
    { name: "Não", value: 13.8 },
  ],
  grafico21: [
    {
      name: "Sim e me tratei em casa",
      value: 81.5,
    },
    {
      name: "Não",
      value: 9.2,
    },
    {
      name: "Sim e precisei ser internado(a) em leito comum",
      value: 7.7,
    },
    {
      name: "Sim e precisei ser internado(a) em UTI (Unidade de Tratamento Intensivo)",
      value: 1.6,
    },
  ],
  grafico23: [
    {
      name: "10 anos ou mais",
      value: 51.4,
    },
    {
      name: "Entre 1 e 3 anos",
      value: 15.1,
    },
    {
      name: "Entre 4 e 6 anos",
      value: 13.8,
    },
    {
      name: "Entre 6 e 9 anos",
      value: 12.4,
    },
    {
      name: "Menos de 1 ano",
      value: 7.3,
    },
  ],
  grafico24: [
    {
      name: "Hospital público",
      value: 56,
    },
    {
      name: "APS (Centro de Saúde/UBS/USF/UBSF/Unidades mistas)",
      value: 35.8,
    },
    {
      name: "H. de Campanha",
      value: 8.7,
    },
    {
      name: "Outros",
      value: 7.3,
    },
    {
      name: "UPA",
      value: 6,
    },
    {
      name: "Hospital privado",
      value: 5,
    },
    {
      name: "SAMU",
      value: 3.2,
    },
    {
      name: "Policlínica ou centro especializado",
      value: 2.8,
    },
    {
      name: "Atendimento remoto",
      value: 2.3,
    },
    {
      name: "Hospital Filantrópico",
      value: 1.4,
    },
  ],
  grafico25: [
    {
      name: "Efetivo (ou estatutário)",
      value: 44.5,
    },
    {
      name: "Contrato com tempo determinado/trabalho temporário da administração pública",
      value: 20.6,
    },
    {
      name: "Contrato sem tempo determinado",
      value: 15.1,
    },
    {
      name: "Contrato direto com a Secretaria de Saúde",
      value: 13.7,
    },
    {
      name: "Empregado (CLT de empresa/fundação pública)",
      value: 6.4,
    },
    {
      name: "Contrato com tempo determinado/trabalho temporário em empresa privada",
      value: 5.5,
    },
    {
      name: "Prestador de serviços eventuais",
      value: 3.2,
    },
    {
      name: "Residente",
      value: 2.3,
    },
    {
      name: "Contratado verbalmente",
      value: 1.8,
    },
    {
      name: "Autônomo (pessoa física)",
      value: 1.8,
    },
    {
      name: "Sem vínculo efetivo",
      value: 0.4,
    },
    {
      name: "Servidor cedido",
      value: 0.4,
    },
    {
      name: "Proprietário/Sócio",
      value: 0.4,
    },
    {
      name: "Ocupante de cargo comissionado na administração pública",
      value: 0.4,
    },
    {
      name: "Autônomo cooperado",
      value: 0.4,
    },
    {
      name: "Autônomo (pessoa jurídica)",
      value: 0.4,
    },
  ],
  grafico26: [
    {
      name: "De 21 a 40 horas",
      value: 64.2,
    },
    {
      name: "De 41 a 60 horas",
      value: 23.9,
    },
    {
      name: "De 61 a 80 horas",
      value: 4.6,
    },
    {
      name: "Menos de 20 horas",
      value: 4.6,
    },
    {
      name: "Mais de 80 horas",
      value: 2.8,
    },
    {
      name: "Ocupante de cargo comissionado na administração pública",
      value: 0.4,
    },
  ],
  grafico27: [
    {
      name: "Sim",
      value: 51.8,
    },
    {
      name: "Não",
      value: 48.2,
    },
  ],
  grafico29: [
    {
      name: "Sim",
      value: 49,
    },
    {
      name: "Não",
      value: 51,
    },
  ],
  grafico30: [
    {
      name: "Sim",
      value: 23.8,
    },
    {
      name: "Não",
      value: 24.8,
    },
  ],
  grafico33: [
    {
      name: "Máscara cirúrgica",
      value: 85.3,
    },
    {
      name: "Luvas de procedimento",
      value: 84.9,
    },
    {
      name: "Gorro/touca/propé descartável",
      value: 83.5,
    },
    {
      name: "Capote/avental",
      value: 81.2,
    },
    {
      name: "Máscara N95/PFF2",
      value: 77.5,
    },
    {
      name: "Proteção ocular/facial",
      value: 73.9,
    },
    {
      name: "Necessário providenciar os próprios EPIs",
      value: 12.4,
    },
    {
      name: "Necessário providenciar os próprios EPIs",
      value: 12.4,
    },
    {
      name: "Necessário improvisar os próprios EPIs",
      value: 7.3,
    },
    {
      name: "Outro",
      value: 5.5,
    },
  ],
  grafico34: [
    {
      name: "Sim",
      value: 23.8,
    },
    {
      name: "Não",
      value: 24.8,
    },
  ],
  grafico35: [
    {
      name: "Necessidade de utilização dos equipamentos por mais tempo que a recomendação",
      value: 30.3,
    },
    {
      name: "Receber poucos equipamentos",
      value: 29.8,
    },
    {
      name: "Solicitação de economia dos equipamentos",
      value: 27.1,
    },
    {
      name: "Receber equipamentos de qualidade inferior ao necessário",
      value: 23.9,
    },
    {
      name: "Outros",
      value: 2.3,
    },
  ],
  grafico36: [
    {
      name: "Sim",
      value: 28.4,
    },
    {
      name: "Não",
      value: 71.6,
    },
  ],
  grafico37: [
    {
      name: "Escuta individual",
      value: 70.5,
    },
    {
      name: "Palestras",
      value: 29.5,
    },
    {
      name: "Cursos",
      value: 22.9,
    },
    {
      name: "Grup. dos trabalhadores",
      value: 14.7,
    },
    {
      name: "Oficinas",
      value: 13.1,
    },
    {
      name: "Outros",
      value: 13.1,
    },
  ],
  grafico38: [
    {
      name: "Trabalho arriscado e perigoso",
      value: 66.1,
    },
    {
      name: "Trabalho cansativo e exaustivo",
      value: 63.8,
    },
    {
      name: "Trabalho que garante o meu sustento",
      value: 33.5,
    },
    {
      name: "Trabalho que ocasiona preconceitos e discriminação",
      value: 33,
    },
    {
      name: "Trabalho inseguro por falta de formação específica",
      value: 32.1,
    },
    {
      name: "Trabalho inseguro por falta de formação específica",
      value: 32.1,
    },
    {
      name: "Trabalho solitário e isolado",
      value: 20.2,
    },
    {
      name: "Trabalho que me identifica, que diz quem eu sou",
      value: 20.2,
    },
    {
      name: "Trabalho que possui reconhecimento social",
      value: 19.7,
    },
    {
      name: "Trabalho que possui reconhecimento da minha família",
      value: 19.3,
    },
    {
      name: "Trabalho inseguro por falta de experiência na área",
      value: 19.3,
    },
    {
      name: "Trabalho que me paralisa e que me deixa impotente",
      value: 12.4,
    },
    {
      name: "Outros",
      value: 3.2,
    },
  ],
};
